<template>
  <SimpleTable card-wrap>
    <thead>
      <tr>
        <th>
          <i :class="['fa-regular', 'mr-2', icon]"></i>
          <span class="info-header text-sm font-bold full-width d-flex-inline"
            >{{ label }}
          </span>
        </th>
      </tr>
    </thead>
    <tr v-if="address" class="list-item-header font-bold">
      <td>{{ addressName }}</td>
    </tr>
    <tr class="list-item">
      <td
        :class="[
          'info',
          {
            'text-danger':
              !address || (address && address.invalid && !address.manual_entry)
          }
        ]"
      >
        <div
          v-if="!address || (address.invalid && !address.manual_entry)"
          class="d-flex align-items-baseline"
        >
          <i class="fa fa-exclamation-circle mr-2" />
          <span>{{ address ? "Invalid" : "Missing Address" }}</span>
        </div>
        <TruncateText v-if="address">
          <span data-cy="billing-address-label-1">{{ addressTextLine1 }}</span>
        </TruncateText>
        <TruncateText v-if="address">
          <span data-cy="billing-address-label-2">{{ addressTextLine2 }}</span>
        </TruncateText>
      </td>
    </tr>
  </SimpleTable>
</template>

<script setup lang="ts">
import { computed } from "vue";

import SimpleTable from "@/components/SimpleTable.vue";
import TruncateText from "@/components/TruncateText.vue";
import { fullAddressLine1, fullAddressLine2 } from "@/mixins";
import { Address } from "@/typings/address";

const props = defineProps({
  address: {
    type: Object as () => Address,
    default: null
  },
  name: {
    type: String,
    default: null
  },
  label: {
    type: String,
    default: "Address"
  },
  icon: {
    type: String,
    default: "fa-location-dot"
  }
});

const addressTextLine1 = computed(() => {
  return fullAddressLine1(props.address);
});

const addressTextLine2 = computed(() => {
  return fullAddressLine2(props.address);
});

const addressName = computed(() => {
  return props.name || props.address.name;
});
</script>

<style lang="scss" scoped>
.list-item {
  &.list-item-collapsed {
    visibility: collapse;
  }
}

.info {
  color: #5d5d5d;
}

.info-header {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}

.info-icon {
  width: 50px;
  text-align: center;
}
</style>
